import { latestChangelogEpoch } from "../models/changelog"

const STORAGE_KEY = "changelogLastSeenEpoch"

export function useChangelogSeen() {
  const lastSeen = Number(localStorage.getItem(STORAGE_KEY)) || 0
  const hasNew = latestChangelogEpoch > lastSeen
  const markSeen = () => localStorage.setItem(STORAGE_KEY, String(latestChangelogEpoch))
  return { hasNew, markSeen }
}
